{
  "en": {
    "select": {
      "actions": {
        "clear": "Clear",
        "filterProject": "Filter on Project",
        "filterUnit": "Filter on Unit",
        "noResults": "No results",
        "noResultsFor": "No results for {search}",
        "reset": "Reset",
        "selectCategory": "Select Category",
        "selectUnit": "Select unit",
        "setToday": "Today",
        "startTyping": "Start typing to search"
      },
      "groups": {
        "customers": "Customers",
        "employees": "Team Members"
      },
      "labels": {
        "allUnits": "All units",
        "contact": "Contact",
        "without": "Without",
        "withoutContact": "Without contact person"
      },
      "placeholders": {
        "contact": "Search person, or choose 'without'..."
      }
    }
  }
}
